import { DISABLE_AUTOMATIC_WRAPPING, WidgetComponent } from "../widget.component";
import { EditableWidget, WIDGET_BIGBLUEBUTTON } from "@shared/models/widget";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LogService } from "@shared/services/log.service";
import { FE_BigBlueButtonWidget } from "@shared/models/integration";
import { SessionStorage } from "@shared/SessionStorage";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { ConfigScreenWidgetComponent } from "../config-screen/config-screen.widget.component";
import { FieldComponent } from "../../../elements/field/field.component";

@Component({
    templateUrl: "bigbluebutton.widget.component.html",
    styleUrls: ["bigbluebutton.widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ConfigScreenWidgetComponent, FieldComponent, TranslatePipe]
})

// Configuration of BigBlueButton widgets
export class BigBlueButtonConfigComponent extends WidgetComponent {
    private readonly bigBlueButtonWidget: FE_BigBlueButtonWidget = <FE_BigBlueButtonWidget>SessionStorage.editIntegration;

    constructor(public translate: TranslateService, logService: LogService) {
        super(WIDGET_BIGBLUEBUTTON, "BigBlueButton Conference", translate, logService, DISABLE_AUTOMATIC_WRAPPING);
    }

    protected OnWidgetsDiscovered(widgets: EditableWidget[]) {
        for (const widget of widgets) {
            widget.data.conferenceUrl = this.templateUrl(widget.url, widget.data);
        }
    }

    protected OnNewWidgetPrepared(widget: EditableWidget): void {
        widget.dimension.newData["conferenceUrl"] = this.bigBlueButtonWidget.options.conferenceUrl;
    }

    protected OnWidgetBeforeAdd(widget: EditableWidget) {
        this.setWidgetOptions(widget);
    }

    protected OnWidgetBeforeEdit(widget: EditableWidget) {
        this.setWidgetOptions(widget);
    }

    private setWidgetOptions(widget: EditableWidget) {
        widget.dimension.newData.url = widget.dimension.newData.conferenceUrl;

        let widgetQueryString = "?" + new URLSearchParams({
            "conferenceUrl": "$conferenceUrl",
            "displayName": "$matrix_display_name",
            "avatarUrl": "$matrix_avatar_url",
            "userId": "$matrix_user_id",
        }).toString();
        widgetQueryString = this.decodeParams(widgetQueryString, Object.keys(widget.dimension.newData).map(k => "$" + k));
        widget.dimension.newUrl = window.location.origin + "/widgets/bigbluebutton" + widgetQueryString;
        this.logService.debug("URL ended up as: " + widget.dimension.newUrl);
    }
}
